// AI Studio: the template size, asked before generating (one template and batches).
// standard 16:9 (YouTube, websites), mobile 9:16 (Reels, Stories, TikTok, Shorts), square 1:1 (feeds).

import React from "react";

export const SIZES = [
  { key: "16:9", label: "Standard", sub: "16:9", w: 22, h: 13 },
  { key: "9:16", label: "Mobile", sub: "9:16", w: 11, h: 19 },
  { key: "1:1", label: "Square", sub: "1:1", w: 16, h: 16 },
];

const SIZE_KEY = "toons_ai_size";

/** The size chosen last time in this browser (standard the first time). */
export function lastSize() {
  try {
    const v = localStorage.getItem(SIZE_KEY);
    return SIZES.some((s) => s.key === v) ? v : "16:9";
  } catch (e) {
    return "16:9";
  }
}

export function rememberSize(size) {
  try {
    localStorage.setItem(SIZE_KEY, size);
  } catch (e) {
    /* storage blocked: asked again next time */
  }
}

/** "Mobile 9:16" for a canvas size. */
export const sizeName = (size) => {
  const s = SIZES.find((x) => x.key === size) || SIZES[0];
  return s.label + " " + s.sub;
};

export default function AISizePicker({ value, onChange }) {
  return (
    <div className="ais-sizes" role="radiogroup" aria-label="Template size">
      <span className="ais-batch-label">Size:</span>
      {SIZES.map((s) => (
        <button
          key={s.key}
          role="radio"
          aria-checked={value === s.key}
          className={"ais-size" + (value === s.key ? " is-on" : "")}
          onClick={() => {
            rememberSize(s.key);
            onChange(s.key);
          }}
        >
          <span className="ais-size-shape"><span style={{ width: s.w, height: s.h }} /></span>
          <span className="ais-size-text">
            <strong>{s.label}</strong>
            <small>{s.sub}</small>
          </span>
        </button>
      ))}
    </div>
  );
}
